export class LsmDenomHashDelayedError extends Error {
  override name = 'LsmDenomHashDelayedError'

  constructor(message = 'Waiting for the chain to index the IBC denom hash.') {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export function isLsmDenomHashDelayedError(error: unknown): error is LsmDenomHashDelayedError {
  return error instanceof LsmDenomHashDelayedError
}

